import React from 'react'
import styles from "@/app/page.module.css";

const SERVICE_BG = "/assets/images/Object-layer-1.png";
const SERVICE_DECOR = "http://localhost:3845/assets/f8f39a9c7e529b214802066682f2be5baede0fe4.svg";
const SERVICE_ICON_PRIMARY = "http://localhost:3845/assets/201b19afa20ec7b44c3af0dff9f8de679aee57ed.png";
const SERVICE_ICON_SECONDARY = "http://localhost:3845/assets/4867f6754e9971fec8fecfa5fb4cad1e5dad3669.png";

const services = [
    {
        id: 1,
        title: "Ear, Nose and Throat Conditions",
        description: "Advanced diagnosis and treatment for ENT disorders.",
        icon: '/assets/Icons/Object-icon-1.png',
    },
    {
        id: 2,
        title: "Paediatric ENT",
        description: "Specialized ENT care for children and young patients.",
        icon: '/assets/Icons/Object-icon-2.png',
    },
    {
        id: 3,
        title: "Thyroid & Parathyroid",
        description: "Expert treatment for thyroid and parathyroid conditions.",
        icon: '/assets/Icons/Object-icon-3.png',
    },
    {
        id: 4,
        title: "Salivary Problems & Sialendoscopy",
        description: "Minimally invasive treatment for salivary gland disorders.",
        icon: '/assets/Icons/Object-icon-4.png',
    },
    {
        id: 5,
        title: "Head & Neck Skin Cancer",
        description: "Comprehensive surgical care for skin cancer conditions.",
        icon: '/assets/Icons/Object-icon-5.png',
    },
    {
        id: 6,
        title: "Voice & Swallowing Problems",
        description: "Treatment for voice, throat and swallowing disorders.",
        icon: '/assets/Icons/Object-icon-6.png',
    },
    {
        id: 7,
        title: "Snoring & Sleep Apnoea",
        description: "Modern solutions for snoring and sleep breathing issues.",
        icon: '/assets/Icons/Object-icon-7.png',
    },
    {
        id: 8,
        title: "Sinus Conditions & Surgery",
        description: "Advanced sinus treatments and endoscopic surgery.",
        icon: '/assets/Icons/Object-icon-8.png',
    },
    {
        id: 9,
        title: "Rhinoplasty",
        description: "Functional and cosmetic nose surgery procedures.",
        icon: '/assets/Icons/Object-icon-9.png',
    },
    {
        id: 10,
        title: "Endoscopic Ear Surgery",
        description: "Minimally invasive advanced ear surgery treatments.",
        icon: '/assets/Icons/Object-icon-10.png',
    },
    {
        id: 11,
        title: "Tear Duct Surgery",
        description: "Specialized procedures for blocked tear ducts.",
        icon: '/assets/Icons/Object-icon-11.png',
    },
    {
        id: 12,
        title: "Advanced Facial Plastics",
        description: "Facial reconstructive and aesthetic surgical care.",
        icon: '/assets/Icons/Object-icon-12.png',
    },
];

export default function Excellance() {
    return (
        <section id="services" className={styles.servicesSection}>
            <img
                src={SERVICE_BG}
                alt="Decorative service background"
                aria-hidden="true"
                className={styles.servicesBackground}
            />
            {/* <img
        src={SERVICE_DECOR}
        alt="Decorative accent"
        aria-hidden="true"
        className={styles.servicesDecor}
      /> */}

            <svg xmlns="http://www.w3.org/2000/svg" width="129" height="86" viewBox="0 0 129 86" fill="none">
                <circle cx="5" cy="5" r="5" fill="url(#paint0_linear_44_3915)" />
                <circle cx="5" cy="24" r="5" fill="url(#paint1_linear_44_3915)" />
                <circle cx="5" cy="43" r="5" fill="url(#paint2_linear_44_3915)" />
                <circle cx="5" cy="62" r="5" fill="url(#paint3_linear_44_3915)" />
                <circle cx="5" cy="81" r="5" fill="url(#paint4_linear_44_3915)" />
                <circle cx="22" cy="5" r="5" fill="url(#paint5_linear_44_3915)" />
                <circle cx="22" cy="24" r="5" fill="url(#paint6_linear_44_3915)" />
                <circle cx="22" cy="43" r="5" fill="url(#paint7_linear_44_3915)" />
                <circle cx="22" cy="62" r="5" fill="url(#paint8_linear_44_3915)" />
                <circle cx="22" cy="81" r="5" fill="url(#paint9_linear_44_3915)" />
                <circle cx="39" cy="5" r="5" fill="url(#paint10_linear_44_3915)" />
                <circle cx="39" cy="24" r="5" fill="url(#paint11_linear_44_3915)" />
                <circle cx="39" cy="43" r="5" fill="url(#paint12_linear_44_3915)" />
                <circle cx="39" cy="62" r="5" fill="url(#paint13_linear_44_3915)" />
                <circle cx="39" cy="81" r="5" fill="url(#paint14_linear_44_3915)" />
                <circle cx="56" cy="5" r="5" fill="url(#paint15_linear_44_3915)" />
                <circle cx="56" cy="24" r="5" fill="url(#paint16_linear_44_3915)" />
                <circle cx="56" cy="43" r="5" fill="url(#paint17_linear_44_3915)" />
                <circle cx="56" cy="62" r="5" fill="url(#paint18_linear_44_3915)" />
                <circle cx="56" cy="81" r="5" fill="url(#paint19_linear_44_3915)" />
                <circle cx="73" cy="5" r="5" fill="url(#paint20_linear_44_3915)" />
                <circle cx="73" cy="24" r="5" fill="url(#paint21_linear_44_3915)" />
                <circle cx="73" cy="43" r="5" fill="url(#paint22_linear_44_3915)" />
                <circle cx="73" cy="62" r="5" fill="url(#paint23_linear_44_3915)" />
                <circle cx="73" cy="81" r="5" fill="url(#paint24_linear_44_3915)" />
                <circle cx="90" cy="5" r="5" fill="url(#paint25_linear_44_3915)" />
                <circle cx="90" cy="24" r="5" fill="url(#paint26_linear_44_3915)" />
                <circle cx="90" cy="43" r="5" fill="url(#paint27_linear_44_3915)" />
                <circle cx="90" cy="62" r="5" fill="url(#paint28_linear_44_3915)" />
                <circle cx="90" cy="81" r="5" fill="url(#paint29_linear_44_3915)" />
                <circle cx="107" cy="5" r="5" fill="url(#paint30_linear_44_3915)" />
                <circle cx="107" cy="24" r="5" fill="url(#paint31_linear_44_3915)" />
                <circle cx="107" cy="43" r="5" fill="url(#paint32_linear_44_3915)" />
                <circle cx="107" cy="62" r="5" fill="url(#paint33_linear_44_3915)" />
                <circle cx="107" cy="81" r="5" fill="url(#paint34_linear_44_3915)" />
                <circle cx="124" cy="5" r="5" fill="url(#paint35_linear_44_3915)" />
                <circle cx="124" cy="24" r="5" fill="url(#paint36_linear_44_3915)" />
                <circle cx="124" cy="43" r="5" fill="url(#paint37_linear_44_3915)" />
                <circle cx="124" cy="62" r="5" fill="url(#paint38_linear_44_3915)" />
                <circle cx="124" cy="81" r="5" fill="url(#paint39_linear_44_3915)" />
                <defs>
                    <linearGradient id="paint0_linear_44_3915" x1="0.310077" y1="0.348837" x2="12.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_44_3915" x1="0.310077" y1="19.3488" x2="12.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_44_3915" x1="0.310077" y1="38.3488" x2="12.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_44_3915" x1="0.310077" y1="57.3488" x2="12.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_44_3915" x1="0.310077" y1="76.3488" x2="12.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint5_linear_44_3915" x1="17.3101" y1="0.348837" x2="29.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint6_linear_44_3915" x1="17.3101" y1="19.3488" x2="29.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint7_linear_44_3915" x1="17.3101" y1="38.3488" x2="29.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint8_linear_44_3915" x1="17.3101" y1="57.3488" x2="29.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint9_linear_44_3915" x1="17.3101" y1="76.3488" x2="29.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint10_linear_44_3915" x1="34.3101" y1="0.348837" x2="46.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint11_linear_44_3915" x1="34.3101" y1="19.3488" x2="46.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint12_linear_44_3915" x1="34.3101" y1="38.3488" x2="46.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint13_linear_44_3915" x1="34.3101" y1="57.3488" x2="46.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint14_linear_44_3915" x1="34.3101" y1="76.3488" x2="46.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint15_linear_44_3915" x1="51.3101" y1="0.348837" x2="63.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint16_linear_44_3915" x1="51.3101" y1="19.3488" x2="63.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint17_linear_44_3915" x1="51.3101" y1="38.3488" x2="63.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint18_linear_44_3915" x1="51.3101" y1="57.3488" x2="63.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint19_linear_44_3915" x1="51.3101" y1="76.3488" x2="63.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint20_linear_44_3915" x1="68.3101" y1="0.348837" x2="80.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint21_linear_44_3915" x1="68.3101" y1="19.3488" x2="80.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint22_linear_44_3915" x1="68.3101" y1="38.3488" x2="80.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint23_linear_44_3915" x1="68.3101" y1="57.3488" x2="80.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint24_linear_44_3915" x1="68.3101" y1="76.3488" x2="80.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint25_linear_44_3915" x1="85.3101" y1="0.348837" x2="97.1053" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint26_linear_44_3915" x1="85.3101" y1="19.3488" x2="97.1053" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint27_linear_44_3915" x1="85.3101" y1="38.3488" x2="97.1053" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint28_linear_44_3915" x1="85.3101" y1="57.3488" x2="97.1053" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint29_linear_44_3915" x1="85.3101" y1="76.3488" x2="97.1053" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint30_linear_44_3915" x1="102.31" y1="0.348837" x2="114.105" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint31_linear_44_3915" x1="102.31" y1="19.3488" x2="114.105" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint32_linear_44_3915" x1="102.31" y1="38.3488" x2="114.105" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint33_linear_44_3915" x1="102.31" y1="57.3488" x2="114.105" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint34_linear_44_3915" x1="102.31" y1="76.3488" x2="114.105" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint35_linear_44_3915" x1="119.31" y1="0.348837" x2="131.105" y2="5.75889" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint36_linear_44_3915" x1="119.31" y1="19.3488" x2="131.105" y2="24.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint37_linear_44_3915" x1="119.31" y1="38.3488" x2="131.105" y2="43.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint38_linear_44_3915" x1="119.31" y1="57.3488" x2="131.105" y2="62.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                    <linearGradient id="paint39_linear_44_3915" x1="119.31" y1="76.3488" x2="131.105" y2="81.7589" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#C2DFFF" />
                        <stop offset="1" stop-color="#2089FF" />
                    </linearGradient>
                </defs>
            </svg>

            <div className={styles.servicesInner}>
                <div className={styles.servicesIntro}>
                    <span className={`${styles.sectionLabel} ${styles.servicesLabel}`}>
                        OUR SERVICE
                    </span>
                    <h2 className={styles.servicesHeading}>
                        Comprehensive ENT & facial care
                    </h2>
                    <p className={styles.servicesText}>
                        Expert care for ear, nose, throat, head & neck conditions using advanced
                        technology and minimally invasive procedures for better recovery and long-term
                        results.
                    </p>
                </div>

                <div className={styles.servicesGrid}>
                    {services.map((service) => (
                        <article key={service.id} className={styles.serviceCard}>
                            <div className={styles.serviceCardIcon}>
                                <img src={service.icon} alt="" style={{

                                    width: '65px',
                                    height: '66px',
                                    aspectRatio: '65/66'
                                }} />
                            </div>
                            <h3 className={styles.serviceCardTitle}>{service.title}</h3>
                            <p className={styles.serviceCardText}>{service.description}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
